/**
 * Buckets Module
 * Handles Bucket Targeting for DFP
 * version 2.0.1
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('AdModules/buckets',[
    "jquery",
    "storage",
    "logging"
], function($, storage, logging) {
    "use strict";

    var _ModuleName = "DFP Buckets Module";

    var _config = {
        storage: { }
     }

    var init = function( config ) {
        // Get Bucket Configuration Data
        $.extend(_config, config.buckets);
        // Get Storage Configuration Data
        $.extend(_config.storage, config.storage);

        // If buckets are enabled, divide traffic
        if(_config.enabled) {
            ;

            // Try and get target from session storage
            _config.target = storage.getSessionStorage(_config.storage.bucketTarget) || 0;
            // If unable to get from storage, calculate new value and store in session storage
            if(_config.target == 0) {
                ;

                _config.target = Math.floor(Math.random() * _config.max) + 1;
                storage.setSessionStorage(_config.storage.bucketTarget, _config.target);
            }            

            ;
            ;
        }
    }

    return {
        init: init,
        isEnabled: (function() { return _config.enabled; }),
        getTarget: (function() { return _config.target; })
    }
});
